import { i18nMark } from 'lingui-react';

const formattedMessages = {
  title: i18nMark('Service Request'),
  reasonForRepair: i18nMark('Reason For Repair'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/ServiceRequestWidget/messages.js